import React,{ useEffect, useState } from 'react';
import SpicyLevel from '../options/SpicyLevel'
import AddBall from '../options/AddBall';
import AddEgg from '../options/AddEgg';
import AddNoodle from '../options/AddNoodle';
import Remark from '../options/Remark';
import Amount from '../options/Amount';
const Food_Options = ({ handleCheckChange, formValues, handleBallChange, handleEggChange, handleAddNoodle, handleInputChange, handleSubtract, handleAdd }) => {
  
  return (
    <>
    <SpicyLevel handleCheckChange={handleCheckChange}/>
    <AddBall formValues = { formValues } handleBallChange = { handleBallChange }/>
    <AddEgg formValues = { formValues } handleEggChange = { handleEggChange }/>
    <AddNoodle formValues = { formValues } handleAddNoodle = { handleAddNoodle }/>
    <Remark formValues = { formValues }  handleInputChange = { handleInputChange }/>
    <Amount handleAdd={ handleAdd } handleSubtract={ handleSubtract } formValues = { formValues }/>
    </>

  );
};

export default Food_Options;
